import {
    FETCH_CHATS_SUCCESS,
    FETCH_CHATS_FAILURE,
    CREATE_CHAT_SUCCESS,
    CREATE_CHAT_FAILURE,
    DELETE_CHAT_SUCCESS,
    DELETE_CHAT_FAILURE,
    RENAME_CHAT_SUCCESS,
    RENAME_CHAT_FAILURE,
    CLEAR_CHAT_ERROR,
    LOGOUT_SUCCESS,
  } from './actionTypes.js';
  
  const initialState = {
    chats: [],
    loading: false,
    error: null,
  };
  
  const chatReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CHATS_SUCCESS:
        return { ...state, chats: action.payload, error: null };

      case FETCH_CHATS_FAILURE:
        return { ...state, error: action.payload };

      case CREATE_CHAT_SUCCESS:
        return { ...state, chats: [action.payload, ...state.chats], error: null };
  
      case CREATE_CHAT_FAILURE:
        return { ...state, error: action.payload };
  
      case DELETE_CHAT_SUCCESS:
        const filtered_chats = state.chats.filter(chat => chat.chat_id !== action.payload.chat_id)
        return {
            ...state,
            chats: filtered_chats,
            error: null
        };
      
      case DELETE_CHAT_FAILURE:
        return { ...state, error: action.payload };
  
      case RENAME_CHAT_SUCCESS:
        return {
          ...state,
          chats: state.chats.map((chat) =>
            chat.chat_id === action.payload.chat_id ? { ...chat, chat_name: action.payload.chat_name } : chat
          ),
          error: null,
        };
  
      case RENAME_CHAT_FAILURE:
        return { ...state, error: action.payload };

      case LOGOUT_SUCCESS:
        return { ...state, chats: [], loading: null, error: null };

      case CLEAR_CHAT_ERROR:
        return { ...state, error: null };
  
      default:
        return state;
    }
  };
  
  export default chatReducer;
  